var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIndeed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30211_196024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5229 0 20 4.47715 20 10C20 15.5229 15.5229 20 10 20C4.47715 20 0 15.5229 0 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89493 15.8411V10.4892C9.04911 10.5033 9.19749 10.5103 9.35286 10.5103C10.0913 10.5103 10.7869 10.3144 11.377 9.96494V15.8399C11.377 16.3419 11.2587 16.7126 11.0292 16.9601C10.8008 17.2063 10.4971 17.3295 10.1284 17.3295C9.76555 17.3295 9.47805 17.2063 9.24155 16.9518C9.01318 16.7055 8.89493 16.3349 8.89493 15.8411ZM8.90886 3.01559C10.4461 2.47019 12.1966 2.49951 13.5112 3.61845C13.7559 3.84364 14.0352 4.12748 14.1465 4.46176C14.2798 4.884 13.6816 4.41719 13.5993 4.35972C13.1704 4.08291 12.7426 3.85068 12.2626 3.69117C9.67749 2.90651 7.23136 4.32453 5.71039 6.52719C5.07511 7.50069 4.66124 8.52581 4.32157 9.65294C4.28448 9.77613 4.25549 9.93681 4.18826 10.0447C4.12102 10.169 4.15928 9.71163 4.15928 9.69638C4.21028 9.23075 4.3065 8.78031 4.42591 8.32994C5.12727 5.93021 6.67843 3.93161 8.90886 3.01559ZM11.8859 7.32713C11.8859 8.34638 11.0686 9.17325 10.0612 9.17325C9.05374 9.17325 8.23761 8.34638 8.23761 7.32713C8.23761 6.30788 9.05374 5.481 10.0612 5.481C11.0686 5.481 11.8859 6.30669 11.8859 7.32713Z",
    fill: "#003A9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30211_196024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIndeed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/indeed.7be39491.svg";
export { ForwardRef as ReactComponent };